module.exports = __webpack_public_path__ + "static/img/01-dashboard.2dbaa9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lti-setup-guide/01-dashboard.png
// module id = 6ZcL
// module chunks = 1